import { SvgImage, SvgType } from '../../../../../../components/base/svg/svg';
import i18n from '../../../../../../translations/strings';

export const titles = [
  {
    name: i18n.t('landing.mixedAudioVideo'),
    svg: <SvgImage type={SvgType.Headphones} />,
  },
  {
    name: i18n.t('landing.liveStreaming'),
    svg: <SvgImage type={SvgType.Camera} />,
  },
  {
    name: i18n.t('landing.wallLed'),
    svg: <SvgImage type={SvgType.Wallet} />,
  },
  {
    name: i18n.t('landing.apeAndBuffet'),
    svg: <SvgImage type={SvgType.Wine} />,
  },
];
